<template>
<b-container fluid>
    <b-row>
      <b-col cols="12">
        <h3 class="informe-titulo">INFORME DE IMPACTO {{ yearActual }}</h3>
      </b-col>
    </b-row>


  <!-- FILTROS -->
  <b-row class="my-3 mx-2">
    <b-col cols="12" md="4">
      <label><small>Seleccionar Estudiante / Docente</small></label>
      <v-select
          v-model="filtros.users"
          :options="filtros.users_items"
          placeholder="Seleccionar usuario"
          @input="aplicarFiltros()"
      >
      </v-select>
    </b-col>
  </b-row>



<b-row >


     <b-col cols="6">
       <b-card  no-body class="shadow-sm w-100">
         <b-card-header class="d-flex justify-content-between align-items-center bg-white">
           <h4 class="informe-subtitulo">Cursos asignados</h4>
           <b-badge variant="primary" pill>
             {{ cursosAsignados.length }}
           </b-badge>
         </b-card-header>

         <b-list-group
             v-if="cursosAsignados.length"
             flush
             class="overflow-auto w-100"
             style="max-height: 400px;"
         >
           <b-list-group-item
               v-for="curso in cursosAsignados"
               :key="curso.id"
               class="d-flex justify-content-between align-items-center w-100"
           >
             <div class="flex-grow-1 mr-3 text-truncate">
               <div class="font-weight-bold text-truncate">{{ curso.nombre }}</div>
               <small class="text-muted">
                 Inscripción: {{ curso.fecha_inscripcion }}
               </small>
             </div>

             <b-badge
                 :variant="getColorAvance(curso.avance)"
                 pill
                 class="px-3 py-2 flex-shrink-0"
             >
               {{ curso.avance }}%
             </b-badge>
           </b-list-group-item>
         </b-list-group>

         <div v-else class="text-center py-5 text-muted">
           <h5 class="mt-3 mb-0">Sin cursos asignados</h5>
         </div>
       </b-card>
     </b-col>
   <b-col cols="6">

     <b-card>
       <h4 class="informe-subtitulo">Actividad por hora</h4>
       <div style="height: 250px">
         <BarChart
             :labels="actividadHora.labels"
             :data="actividadHora.values"
             label="Interacciones"
             backgroundColor="#6b20c1"

         />
       </div>
     </b-card>

   </b-col>
</b-row>

<!--  tabla bitacora personal-->
<b-row>
   <b-col cols="12">
     <b-card no-body class="shadow-sm mt-3">
       <b-card-header class="bg-white d-flex justify-content-between align-items-center">

         <h4 class="informe-subtitulo">Bitácora</h4>
         <b-form-input
             v-model="bitacoraFilter"
             size="sm"
             placeholder="Buscar..."
             style="max-width: 250px;"
         ></b-form-input>
       </b-card-header>

       <b-card-body>
         <b-table
             class="table data-table"
             striped
             hover
             borderless
             :items="bitacora_items"
             :fields="bitacora_headers"
             :current-page="bitacoraCurrentPage"
             :per-page="bitacoraPerPage"
             :filter="bitacoraFilter"
             stacked="md"
             show-empty
             small
         >
           <template #empty="scope">
             <h5 class="text-center text-muted py-3">
               {{ scope.emptyText = 'Por el momento no hay registros que mostrar.' }}
             </h5>
           </template>

           <template #emptyfiltered="scope">
             <h5 class="text-center text-muted py-3">
               {{ scope.emptyFilteredText = 'No hay registros que concuerden con los parámetros de búsqueda.' }}
             </h5>
           </template>

           <template #cell(fecha)="row">
             <span class="text-muted">{{ row.item.fecha }}</span>
           </template>

           <template #cell(hora)="row">
             <span class="text-muted">{{ row.item.hora }}</span>
           </template>

           <template #cell(tipo)="row">
             <b-badge :variant="getColorTipo(row.item.tipo)" pill>
               {{ row.item.tipo }}
             </b-badge>
           </template>

           <template #cell(detalle)="row">
             <span>{{ row.item.detalle }}</span>
           </template>
         </b-table>

         <div class="d-flex justify-content-between align-items-center mt-2" v-if="bitacora_items.length">
           <small class="text-muted">
             Total: {{ bitacora_items.length }} registros
           </small>
           <b-pagination
               v-model="bitacoraCurrentPage"
               :total-rows="bitacora_items.length"
               :per-page="bitacoraPerPage"
               size="sm"
               class="mb-0"
           ></b-pagination>
         </div>
       </b-card-body>
     </b-card>


   </b-col>
</b-row>

  </b-container>
  </template>

  <script>

import BarChart from '@/components/Graficas/BarChart.vue'
import Bugsnag from "@bugsnag/js";
export default {
  name: 'DashboardGraficas2',
  components: {
    BarChart,
  },

mounted() {
  this.getCursosAsignados();
  this.getActividadPorHora();
  this.getBitacoraPersonal();
  this.getUsuariosDominio();
},
methods: {


  //hacer la consulta, again
  aplicarFiltros() {
    //console.log();
    this.getCursosAsignados();
    this.getActividadPorHora();
    this.getBitacoraPersonal();
  },

  async getUsuariosDominio() {
    try {
      let response = await this.$api.get(`/api/graficas/get-usuarios-dominio`);
      let { success, usuarios } = response.data;
      if (success) {
        this.filtros.users_items = usuarios;
      }
    } catch (error) {
      Bugsnag.notify(new Error('Método: getUsuariosDominio() ' + error.message));

    }
  },

  // bitácora personal del usuario seleccionado
  async getBitacoraPersonal() {
    try {

      let params = {
        user_id: this.filtros.users.id || 0
      };

      const response = await this.$api.get('/api/graficas/get-bitacora-personal', { params })
      const { success,  data } = response.data

      if (success) {
        this.bitacora_items = data
      }

    } catch (error) {
      console.error('❌ Error al obtener bitácora:', error)

    }
  },

// helper para colorear el badge según el tipo
  getColorTipo(tipo) {
    const map = {
      'Acceso':     'success',
      'Video':      'primary',
      'Navegación': 'info',
      'Actividad':  'warning',
      'Evaluación': 'danger',
      'Entrega':    'dark',
      'Material':   'secondary',
      'Duda':       'info',
      'Curso':      'success',
      'Edición':    'warning',
      'Otro':       'light',
    }
    return map[tipo] || 'secondary'
  }, //getBitacoraPersonal

// cursos asignados al usuario seleccionado
  async getCursosAsignados() {
    try {

      let params = {
        user_id: this.filtros.users.id || 0
      };

      const response = await this.$api.get('/api/graficas/get-cursos-asignados', { params })
      const { success,  data } = response.data

      if (success) {
        this.cursosAsignados = data
      }


    } catch (error) {
      console.error('❌ Error al obtener cursos asignados:', error)

    }
  },

// helper para colorear el chip según el avance
  getColorAvance(avance) {
    if (avance >= 80) return 'success'
    if (avance >= 50) return 'primary'
    if (avance >= 25) return 'warning'
    return 'secondary'
  }, //getCursosAsignados


// actividad por hora del usuario seleccionado
  async getActividadPorHora() {
    try {

      let params = {
        user_id: this.filtros.users.id || 0
      };

      const response = await this.$api.get('/api/graficas/get-actividad-por-hora', { params })
      const { success,  data } = response.data

      if (success) {
        this.actividadHora.labels = data.labels
        this.actividadHora.values = data.values
      }


    } catch (error) {
      console.error('❌ Error al obtener actividad por hora:', error)

    }
  },//getActividadPorHora

},//methods
  
data() {
    return {
      yearActual: new Date().getFullYear(),
      cursosAsignados: [],

      actividadHora: {
        labels: [],
        values: [],
      },

      filtros: {
        users: { id: 0, label: 'Selecciona un usuario' },
        users_items: []
      },

// datos bitacroa personal
      bitacora_items: [],
      bitacora_headers: [
        { key: 'fecha',   label: 'FECHA',   sortable: true },
        { key: 'hora',    label: 'HORA',    sortable: true },
        { key: 'tipo',    label: 'TIPO',    sortable: true },
        { key: 'detalle', label: 'DETALLE', sortable: false },
      ],
      bitacoraCurrentPage: 1,
      bitacoraPerPage: 10,
      bitacoraFilter: null,



//datos para la tabla
      usuarios_items: [],
      usuarios_headers: [
        { key: 'fecha', label: 'FECHA', sortable: true },
        { key: 'programa', label: 'PROGRAMA', sortable: true },
        { key: 'curso', label: 'CURSO', sortable: true },
        { key: 'actividad', label: 'ACTIVIDAD', sortable: true },
        { key: 'usuario', label: 'USUARIO', sortable: true },
        { key: 'estado', label: 'ESTADO', sortable: true }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterOn: [],
      search: '',

    }//return
  }
}
</script>

<style scoped>
.stats-cards-row {
  margin-bottom: 30px;
}

/* Card principal */
.stat-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
  height: 100%;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

/* Icono */
.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  flex-shrink: 0;
}

.stat-icon i {
  color: white;
}

/* Contenido */
.stat-content {
  flex: 1;
}

.stat-value {
  font-size: 28px;
  font-weight: 700;
  margin: 0;
  color: #333;
  line-height: 1.2;
}

.stat-label {
  font-size: 14px;
  color: #666;
  margin: 4px 0 0;
  font-weight: 500;
}

/* Variantes de colores */

/* Primary (Morado) - Programas Activos */
.stat-card-primary {
  border-left-color: #6b20c1;
}

.stat-card-primary .stat-icon {
  background: linear-gradient(135deg, #6b20c1 0%, #8e44d1 100%);
}

.stat-card-primary:hover {
  border-left-color: #8e44d1;
}

/* Success (Verde) - Usuarios Únicos */
.stat-card-success {
  border-left-color: #28a745;
}

.stat-card-success .stat-icon {
  background: linear-gradient(135deg, #28a745 0%, #3db85f 100%);
}

.stat-card-success:hover {
  border-left-color: #3db85f;
}

/* Warning (Naranja) - Ventana de Foco */
.stat-card-warning {
  border-left-color: #ff5e20;
}

.stat-card-warning .stat-icon {
  background: linear-gradient(135deg, #ff5e20 0%, #ff7840 100%);
}

.stat-card-warning:hover {
  border-left-color: #ff7840;
}

/* Info (Azul) - Recursos Vistos */
.stat-card-info {
  border-left-color: #17a2b8;
}

.stat-card-info .stat-icon {
  background: linear-gradient(135deg, #17a2b8 0%, #20c4db 100%);
}

.stat-card-info:hover {
  border-left-color: #20c4db;
}

/* Responsive */
@media (max-width: 992px) {
  .stat-value {
    font-size: 24px;
  }
  
  .stat-label {
    font-size: 13px;
  }
  
  .stat-icon {
    width: 48px;
    height: 48px;
    font-size: 20px;
  }
}

@media (max-width: 576px) {
  .stat-card {
    padding: 20px;
    gap: 16px;
  }
  
  .stat-value {
    font-size: 22px;
  }
  
  .stat-label {
    font-size: 12px;
  }
}
.informe-titulo {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 31px;
  color: #434343;
  margin: 1rem 0;
}

.informe-subtitulo {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 20px;
  color: #434343;
  margin: 1rem 0;
}

</style>